goog.provide('el8.appchart.visitNote.saveTemplateDialog');

goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.appservice.notifier');
goog.require('el8.template.appchart.dialog.saveTemplate');
goog.require('el8.service.urls');


el8.appchart.visitNote.saveTemplateDialog = (function() {

    var checklist = null,
        checklistType = null,
        buildTemplateMenu = null;
    
    var that = new el8.uiwidget.FormDialog({
        title: 'Save New Template',
        modal: true,
        autoHeight: true,
        width: 300,
        contentFn: el8.template.appchart.dialog.saveTemplate.content,
        showXButton: el8Globals.READ_ONLY
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'name',
                type: 'input',
                infoText: 'name...',
                maxLength: 30
            }
        ]
    });

    form.addButton('ok', 'Save', function(form) {
        var name = form.getVal('name');
        if (!name) {
            el8.uiwidget.alert('Please enter a name for this template.');
            return false;
        }

        function _doSave(checklist, checklistId) {
            // checklistId won't necessarily be in the checklist JSON
            // because we found it by doing a GET on the checklist name
            el8.appservice.notifier.notify(
                'Creating new ' + checklistType.toUpperCase() + ' template...');

            var data = checklist.asMap();
            data['name'] = name;

            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('checklistTemplates', [checklistId]),
                data: JSON.stringify(data),
                success: function(data) {
                    el8.appservice.notifier.notify(
                        'New ' + checklistType.toUpperCase() + ' template created.');
                    el8.data.checklistTemplates.create(data);
                    buildTemplateMenu();
                    form.disable();
                    that.hide();
                }
            });
        }

        // before calling _doSave, see if this name already exists and ask the user if so
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('checklistTemplates'),
            data: { name: name },
            success: function(data) {
                if (data && data.id) {
                    el8.uiwidget.confirm(
                        "There's already a Template named \""+name+".\" " +
                            "Do you want to replace the existing template?",
                        function() {
                            _doSave(checklist, data.id);
                        },
                        function() {
                            form.disable();
                            that.hide();
                        }
                    );
                } else {
                    _doSave(checklist);
                }
            }
        });

    }, true);
    form.addButton('cancel', 'Cancel', function(form) {
        form.disable();
        that.hide();
    }, false);
    that.setForm(form);
    
    var super_show = that.show;
    that.show = function(_checklist, _buildTemplateMenu) {
        super_show.call(that);
        checklist = _checklist;
        checklistType = _checklist.getType();
        buildTemplateMenu = _buildTemplateMenu;
        form.enable();
    };
    
    return that;
})();
